import { Component, Input, OnInit, Optional, ViewEncapsulation } from '@angular/core';
import { ScreenType } from 'projects/common/model/ScreenType';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { TagTextData } from '../tag-text/tag-text.component';
import { TipMessage } from '../tip-message/tip-message.model';
import { MediaPictureService } from '../../services/media-picture.service';
import { TextAlign } from 'projects/common/model/ModuleModel';

export interface Icon {
  image: string;
}

export enum TitleCardVariant {
  DEFAULT = 'DEFAULT',
  ACCESS_POINT = 'ACCESS_POINT'
}

export interface MainTitle {
  icon?: Icon;
  pre_title?: TagTextData;
  title?: TagTextData;
  sub_title?: TagTextData;
  more_text?: TagTextData;
  tip_message?: TipMessage;
  css_options?: any;
  text_vertical_align?: TextAlign;
  text_horizontal_align?: TextAlign;
  title_in_nav_bar?: boolean;
  title_card_variant?: TitleCardVariant;
  card_image?: {
    src: string;
    alt?: string;
  };
  card_link?: string;
}

@Component({
  selector: 'main-title',
  template: `
    <div class="main-text">
      <div *ngIf="iconSrc">
        <img [src]="iconSrc" alt="">
      </div>
      <tag-text class="pretitle-container eva-3-overline-1" *ngIf="data.pre_title" [data]="data.pre_title | tagTextDefaultColor: preTitleColor"></tag-text>
      <div class="title-wrapper">
        <tag-text class="title" *ngIf="data.title" [data]="data.title | tagTextDefaultColor: titleColor"></tag-text>
        <tip-message *ngIf="validTipMessage()" [tipMessage]="data.tip_message!" [moduleId]="moduleId" [uniqueId]="uniqueId"></tip-message>
      </div>
      <tag-text class="subtitle-container" *ngIf="data.sub_title" [data]="data.sub_title | tagTextDefaultColor: subtitleColor"></tag-text>
      <tag-text class="more-text-container" *ngIf="(display === 'DESKTOP' || this.showMoreTextMobile) && data.more_text" [data]="data.more_text | tagTextDefaultColor: textColor"></tag-text>
    </div>
  `,
  styleUrls: ['./main-title.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainTitleComponent implements OnInit {
  @Input() data: MainTitle;
  @Input() titleColor;
  @Input() preTitleColor: string;
  @Input() subtitleColor: string;
  @Input() textColor: string;
  @Input() defaultColor = 'white';
  @Input() moduleId: string;
  @Input() uniqueId?: string;
  @Input() showMoreTextMobile = false
  display: ScreenType;
  iconSrc: string;

  constructor(landingModelService: LandingModelService, private mediaPictureService: MediaPictureService) {
    this.display = landingModelService.getLandingModel().device.type;
  }

  ngOnInit() {
    if (this.data.icon?.image) {
      this.iconSrc = this.mediaPictureService.getMediaUrl(this.data.icon.image) + '/68x38';
    }
    if (this.defaultColor) {
      if (!this.titleColor) this.titleColor = this.defaultColor;
      if (!this.preTitleColor) this.preTitleColor = this.defaultColor;
      if (!this.subtitleColor) this.subtitleColor = this.defaultColor;
      if (!this.textColor) this.textColor = this.defaultColor;
    }
  }

  validTipMessage(): boolean {
    return !!(this.data.tip_message?.text && (this.data.tip_message.image || this.data.tip_message.video));
  }

}
